import moment from 'moment'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { EuiButton, EuiFieldText, EuiFormRow, EuiSpacer } from '@elastic/eui'

import { useGetMasterCampaignQuery, useUpdateMasterCampaignMutation } from 'api/rtkQueryApi/platform/masterCampaignsApi'

import { RootState } from '../../../app/rootReducer'
import { IPaymentMethodPickerState, PaymentMethodPicker } from '../../../components/payments/PaymentMethodPicker'

export const MasterCampaignSettings = ({ masterCampaignId }: { masterCampaignId: string }) => {
  const { currentUser } = useSelector((state: RootState) => state.app)

  const [updateMasterCampaignMutation, updateMasterCampaignMutationResult] = useUpdateMasterCampaignMutation()
  const masterCampaign = useGetMasterCampaignQuery({ masterCampaignId }, { skip: !masterCampaignId })

  const [name, setName] = useState<string>(masterCampaign.data?.name ?? '')
  const [activateDaysBeforeStartDate, setActivateDaysBeforeStartDate] = useState(masterCampaign.data?.activateDaysBeforeStartDate)
  const [paymentMethodPickerState, setPaymentMethodPickerState] = useState<IPaymentMethodPickerState>({
    selectedPaymentMethodId: masterCampaign.data?.paymentMethodSelectedDate ? masterCampaign.data?.paymentMethodId ?? 'default' : '',
    selectedCampaignSlotId: ''
  })
  useEffect(() => {
    if (masterCampaign.data) {
      setActivateDaysBeforeStartDate(masterCampaign.data.activateDaysBeforeStartDate)
      setPaymentMethodPickerState({
        selectedPaymentMethodId: masterCampaign.data?.paymentMethodSelectedDate ? masterCampaign.data?.paymentMethodId ?? 'default' : '',
        selectedCampaignSlotId: ''
      })
      setName(masterCampaign.data.name)
    }
  }, [masterCampaign.data])

  const getPaymentMethodId = () => {
    if (paymentMethodPickerState.selectedPaymentMethodId === '') {
      return
    }
    return paymentMethodPickerState.selectedPaymentMethodId === 'default' ? undefined : paymentMethodPickerState.selectedPaymentMethodId
  }

  const getPaymentMethodSelectedDate = () => {
    if (paymentMethodPickerState.selectedPaymentMethodId === '') {
      return
    }
    if (masterCampaign.data?.paymentMethodSelectedDate) {
      if (getPaymentMethodId() !== masterCampaign.data.paymentMethodId) {
        return moment().toDate().toISOString()
      }
      return masterCampaign.data.paymentMethodSelectedDate.toDate().toISOString()
    }
    return moment().toDate().toISOString()
  }

  const onCampaignSettingsSave = async () => {
    if (!currentUser || !masterCampaign.data) {
      return
    }

    await updateMasterCampaignMutation({
      masterCampaignId,
      data: {
        name,
        paymentMethodId: getPaymentMethodId(),
        paymentMethodSelectedDate: getPaymentMethodSelectedDate(),
        activateDaysBeforeStartDate: activateDaysBeforeStartDate,
        updatedBy: currentUser.email,
        masterCampaignItems: masterCampaign.data?.items
      }
    })
  }

  return (
    <>
      <EuiFormRow label={'Master Campaign Name'}>
        <EuiFieldText placeholder='' value={name} onChange={e => setName(e.target.value)} />
      </EuiFormRow>
      <PaymentMethodPicker paymentMethodPickerState={paymentMethodPickerState} updatePaymentMethodPickerState={setPaymentMethodPickerState} useDefaultPaymentWhenEmpty={!!masterCampaign.data?.paymentMethodSelectedDate} />
      <EuiSpacer />
      <EuiButton fill onClick={onCampaignSettingsSave} isLoading={updateMasterCampaignMutationResult.isLoading}>
        Save
      </EuiButton>
    </>
  )
}
